<!--
 *                        _oo0oo_
 *                       o8888888o
 *                       88" . "88
 *                       (| -_- |)
 *                       0\  =  /0
 *                     ___/`---'\___
 *                   .' \\|     |// '.
 *                  / \\|||  :  |||// \
 *                 / _||||| -:- |||||- \
 *                |   | \\\  - /// |   |
 *                | \_|  ''\---/''  |_/ |
 *                \  .-\__  '-'  ___/-. /
 *              ___'. .'  /--.--\  `. .'___
 *           ."" '<  `.___\_<|>_/___.' >' "".
 *          | | :  `- \`.;`\ _ /`;.`/ - ` : | |
 *          \  \ `_.   \_ __\ /__ _/   .-` /  /
 *      =====`-.____`.___ \_____/___.-`___.-'=====
 *                        `=---='
 *
 *
 *      ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 *
 *            佛祖保佑       永不宕机     永无BUG
 *
 * @Author: DY
 * @Date: 2021-08-20 12:00:14
 * @LastEditTime: 2021-08-20 15:56:54
 * @Description: 选择泵车公司
 * @Param:
 * @FilePath: \JiYun_Mobile_test\src\views\salesTerminal\pumpTruckDistribution\selectPumpTruckCompany.vue
 -->


<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="selectPumpTruckCompany">
            <van-nav-bar
                title="选择泵车公司"
                left-text="添加"
                left-arrow
                @click-left="swiperright"
            >
            </van-nav-bar>
            <section>
                <van-checkbox-group v-model="result">
                    <template v-for="(item, index) in pumpTrucklist">
                        <van-checkbox :name="item.pump_company_code" :key="`pumpTruck_${index}`">
                            {{ item.pump_company_name }}
                        </van-checkbox>
                    </template>
                </van-checkbox-group>
            </section>
            <footer>
                <van-button
                    block
                    type="primary"
                    color="#E81B1B"
                    @click="confirmSelection"
                >
                    确定
                </van-button>
            </footer>
        </div>
    </v-touch>
</template>
<script>
export default {
    name: 'select-pump-truck-company',
    components: {},
    props: {},
    data() {
        return {
            // 已选
            result: [],
            // 物流公司
            pumpTrucklist: [],
        };
    },
    computed: {},
    watch: {},
    async created() {
        this.pumpTrucklist = await this.getPumpTrucklist();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上一页
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 确认选择
        confirmSelection() {
            const row = this.pumpTrucklist.filter(item => this.result.indexOf(item.pump_company_code) > -1);
            this.$router.isBack = 1;
            this.$router.replace({
                name: 'addPumpTruckCompany',
                params: {
                    selectData: row,
                },
            });
            this.$router.go(-1);
        },
        // 获取物流公司数据
        getPumpTrucklist() {
            return this.$axios.$get('/interfaceApi/logistics/carcompany/pumptruckcompanies', { defEx: true });
        },
    },
};
</script>
<style lang="stylus" scoped>
.selectPumpTruckCompany
    height 100%
    section
        height calc(100% - 84rpx)
        overflow scroll
        -webkit-overflow-scrolling touch
        .van-checkbox-group
            .van-checkbox
                height 50rpx
                line-height 50rpx
                padding 0 17rpx
                border-bottom 1px solid #F0F0F0
    footer
        .van-button
            height 40rpx
</style>